module.exports = __webpack_public_path__ + "inc/img/pic_office_03.ef45f0aa.png";